<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Package</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="packages.id === null">New</span>
              <span v-else>
                {{ packages.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group row">
              <label for="product_no" class="col-sm-3 col-form-label text-left">Service</label>
              <div class="col-sm-9">
                <select v-model="packages.product_no" class="form-control">
                  <option v-for="s in getService" :key="s.product_no" :value="s.product_no">{{ s.product_name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="packages.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="price" class="col-sm-3 col-form-label text-left">Price</label>
              <div class="col-sm-9">
                <input type="text" v-model="packages.price" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="valid_date" class="col-sm-3 col-form-label text-left">Valid Date</label>
              <div class="col-sm-9">
                <el-date-picker style="width: 100%" v-model="packages.valid_date" type="datetime" placeholder="Valid Date"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updatePackage" class="btn btn-sm btn-primary pull-right" v-show="packages.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createPackage" class="btn btn-sm btn-primary pull-right" v-show="packages.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <pre>
      <!-- {{ packages }} -->
    </pre>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { packageUrl, getHeader } from '../../config'

export default {
  name: 'PackageForm',
  props: ['packages'],
  computed: {
    ...mapState({
      productListAll: state => state.products.productListAll
    }),
    getService () {
      var data = this.productListAll.filter(p => p.type_id === 'Service').filter(p => p.active === true)
      return data
    }
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updatePackage () {
      axios.put(packageUrl + '/' + this.packages.id, this.packages, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Package', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createPackage () {
      axios.post(packageUrl, this.packages, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Package', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
